/**
 * Per-surface obligee step config (Phase 9.9E).
 * Surfaces: creation | historic | retrieval | blanket
 * Modes: globalState (wizard steps) | rhf (blanket flows)
 */

export const DEFAULT_OBLIGEE_NAME_VA =
  "Secretary, U.S. Department of Veterans Affairs";
export const DEFAULT_OBLIGEE_NAME_FLORIDA = "Governor of Florida (Ron Desantis)";

export function getDefaultObligeeName(bondType) {
  return bondType === "VA"
    ? DEFAULT_OBLIGEE_NAME_VA
    : DEFAULT_OBLIGEE_NAME_FLORIDA;
}

export function findDefaultObligee(obligees, bondType) {
  const defaultObligeeName = getDefaultObligeeName(bondType);
  return obligees.find((o) => o.obligee_name === defaultObligeeName);
}

const BASE_GLOBAL_STATE = {
  mode: "globalState",
  scrollToTopOnMount: true,
  showOuterCard: true,
  useGridLayout: false,
  fullWidthAddButton: false,
  hideAddWhenDisabled: false,
};

const BASE_BLANKET = {
  surface: "blanket",
  mode: "rhf",
  scrollToTopOnMount: false,
  showOuterCard: false,
  useGridLayout: true,
  fullWidthAddButton: true,
  hideAddWhenDisabled: false,
  showValidationErrors: false,
  normalizeId: false,
  blockFloridaDuplicate: false,
  showGoogleAutocomplete: true,
  defaultStrategy: "none",
  debugRetrieveLogs: false,
};

export const OBLIGEE_SURFACE_CONFIG = {
  creation: {
    ...BASE_GLOBAL_STATE,
    surface: "creation",
    showValidationErrors: true,
    normalizeId: true,
    blockFloridaDuplicate: true,
    showGoogleAutocomplete: false,
    defaultStrategy: "delayedWithRef",
    debugRetrieveLogs: false,
  },
  historic: {
    ...BASE_GLOBAL_STATE,
    surface: "historic",
    showValidationErrors: true,
    normalizeId: false,
    blockFloridaDuplicate: false,
    showGoogleAutocomplete: true,
    defaultStrategy: "immediateOnMount",
    debugRetrieveLogs: false,
  },
  retrieval: {
    ...BASE_GLOBAL_STATE,
    surface: "retrieval",
    showValidationErrors: false,
    normalizeId: true,
    blockFloridaDuplicate: false,
    showGoogleAutocomplete: true,
    defaultStrategy: "immediateUnlessSuppressed",
    debugRetrieveLogs: true,
  },
  blanket: {
    ...BASE_BLANKET,
  },
};

export function getObligeeSurfaceConfig(surface, overrides = {}) {
  const base =
    OBLIGEE_SURFACE_CONFIG[surface] || OBLIGEE_SURFACE_CONFIG.creation;
  return { ...base, ...overrides };
}
